// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * Converts empty or whitespace-only strings to null.
 *
 * @param value - The string to normalize
 * @returns null if value is empty or whitespace, otherwise returns the original value
 */
export const nullifyEmptyString = (value: string | null): string | null => {
  return value?.trim() === '' ? null : value;
};
